import { Icon } from '@chakra-ui/icons'
import { IconProps } from '@chakra-ui/react'
import { FC } from 'react'

interface GoogleSafeBrowsingIconProps extends IconProps {
  theme?: 'phthalo' | 'grayscale'
}

export const GoogleSafeBrowsingIcon: FC<GoogleSafeBrowsingIconProps> = (props) => {
  const themeColors = (theme?: string) => {
    if (!theme) {
      return ['#66bb6a', '#388e3c', '#e0e0e0']
    }
    return theme === 'phthalo' ? ['#ADEDD6', '#235E64', '#368081'] : ['#939393', '#5A5A5A', '#B7B7B7']
  }

  return (
    <Icon xmlSpace="preserve" id="Layer_1" x={0} y={0} viewBox="0 0 36.3 50.4" {...props}>
      <style>{`.st2{fill:${themeColors(props.theme)[0]}}.st4{fill:${themeColors(props.theme)[0]}}`}</style>
      <path d="M0 6.9v4.8c0 13.4 0 22.7 7.8 30.5 3 3 10.3 7.9 10.3 7.9V6.9H0z" fill={themeColors(props.theme)[2]} />
      <path
        d="M36.3 6.9H18.2v43.2s7.4-4.9 10.4-7.9c7.8-7.8 7.8-16 7.8-28.7l-.1-6.6z"
        fill={themeColors(props.theme)[1]}
      />
      <path
        d="M14.5 39.3c1-.9 2.4-1.4 3.8-1.4s2.6.5 3.6 1.2L18.2 43l-3.7-3.7zM23.3 37.7c-1.4-1.1-3.1-1.7-5-1.7-2 0-3.8.7-5.2 1.9L12 36.2c1.7-1.4 3.9-2.2 6.4-2.2 2.3 0 4.4.8 6.1 2l-1.2 1.7zM10.1 32c2.3-1.6 5.2-2.6 8.2-2.6 2.9 0 5.6.9 7.9 2.3l-.8 2c-2-1.4-4.5-2.3-7.1-2.3-2.8 0-5.4.9-7.4 2.5l-.8-1.9z"
        className="st2"
      />
      <circle cx={18.1} cy={20.1} r={6} className="st2" />
      <path
        d="M36.3 6.9V3.2c0-1.3-1.8-3.2-3.5-3.2H3.2C1.5 0 0 1.9 0 3.2v3.7h36.3z"
        fill={themeColors(props.theme)[2]}
      />
      <circle cx={4.5} cy={3.9} r={1.1} className="st4" />
      <circle cx={8.4} cy={3.9} r={1.1} className="st4" />
    </Icon>
  )
}
